
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 6C117.9 6 6 117.9 6 256s111.9 250 250 250 250-111.9 250-250S394.1 6 256 6zm-32.3 28.5c-24.3 30.2-43.2 63.9-56.2 99.7-26-7-51.4-17.2-75.5-30.6 34-36.5 80-61.7 131.7-69.1zM80.8 116.7c25.9 14.7 53.2 25.9 81.3 33.5-9.7 31.2-15.1 63.9-15.9 97.3H32.3c1.8-49.3 19.7-94.6 48.5-130.8zM32.3 264.4h113.9c.8 33.5 6.2 66.1 15.9 97.3-28.1 7.7-55.4 18.8-81.3 33.5-28.8-36.1-46.7-81.4-48.5-130.8zM92 408.3c24.1-13.3 49.4-23.5 75.5-30.6 13.1 35.9 32 69.5 56.2 99.7C172 470 126 444.9 92 408.3zm155.6 71.3c-27.8-31.5-49.2-67.3-63.6-105.9 20.9-4.5 42.2-7.1 63.6-7.6v113.5zm0-130.3c-23.2.5-46.3 3.4-69.1 8.4-9.4-29.9-14.6-61.2-15.4-93.3h84.5v84.9zm0-101.7h-84.5c.8-32.1 6-63.4 15.4-93.3 22.7 5.1 45.9 7.9 69.1 8.4v84.9zm0-101.8c-21.3-.5-42.6-3.1-63.6-7.6 14.3-38.6 35.7-74.4 63.6-105.9v113.5zm232.1 101.8h-114c-.8-32.9-6.1-65.6-15.9-97.3 28.2-7.7 55.6-18.9 81.5-33.6 28.7 36.2 46.6 81.5 48.4 130.9zM420 103.7c-24.1 13.4-49.6 23.6-75.7 30.6-12.9-35.4-31.6-69.2-56.1-99.8C340 41.9 386 67.1 420 103.7zM264.5 32.4c28.2 31.9 49.3 67.9 63.4 105.9-20.9 4.5-42.1 7-63.4 7.6V32.4zm0 130.3c23.1-.5 46.2-3.3 68.9-8.4 9.5 30.3 14.7 61.7 15.4 93.2h-84.3v-84.8zm0 101.7h84.3c-.8 31.5-5.9 62.9-15.4 93.2-22.7-5-45.7-7.8-68.9-8.4v-84.8zm0 101.8c21.3.5 42.5 3 63.4 7.6-14.1 38-35.2 74-63.4 105.9V366.2zm23.8 111.3c24.5-30.6 43.2-64.4 56.1-99.8 26.1 7 51.5 17.2 75.7 30.6-34.1 36.6-80.1 61.8-131.8 69.2zm142.9-82.2c-25.9-14.7-53.3-25.9-81.5-33.6 9.8-31.6 15.1-64.4 15.9-97.3h114c-1.7 49.4-19.6 94.7-48.4 130.9z"}})])
          )
        }
      }
    